// extracted by mini-css-extract-plugin
module.exports = {"photoContainer":"property_photo_photoContainer__kwlzm","picture":"property_photo_picture__23CTa"};